<template>
  <fragment>
    <label class="form__label primary--text">
      {{ labelText }}
    </label>
    <VueSelect
      class="custom__select mt-2"
      v-bind="[$attrs, $props]"
      v-on="$listeners"
      label="nome_fantasia"
      :clearable="false"
      :components="{ OpenIndicator }"
      @search="onSearch"
    />
  </fragment>
</template>

<script>
import "vue-select/dist/vue-select.css";
import VueSelect from "vue-select";

const SearchComponents = {
  OpenIndicator: {
    render: createElement =>
      createElement(
        "i",
        {
          class: "fa fa-search"
        },
        null
      )
  }
};

export default {
  name: "SuggestInput",
  components: { VueSelect },
  props: {
    value: Object,
    labelText: String,
    searchTerm: String
  },
  data: () => ({ ...SearchComponents }),
  methods: {
    onSearch(search, loading) {
      this.$emit("search", search, loading);
    }
  }
};
</script>

<style lang="sass">
.custom__select
  background: white
  border-radius: 2px

  > *
    border-radius: 2px

  .vs__selected,
  .vs__search
    margin-bottom: 3px

  .vs__actions
    border: none !important
    border-left: 1px solid #D5D5E0 !important
    border-radius: 0px
    text-align: center
    width: 40px !important
    margin: 0 !important
    background: #FFF
    box-sizing: border-box
    color: #059EE4
    font-size: 18px
    justify-content: center
    padding: 0

  .vs__dropdown-toggle
    padding: 0 !important

  .vs__dropdown-menu
    padding: 5px 0
</style>
